<template lang="pug">
v-app
  em-menu
  v-content
    v-container
      .content-area
        .desciption
          h1.display-1 バナー管理
          p トップページに表示されるバナーの追加/編集/削除ができます
          .alert(v-show="cache != null")
            v-alert(:value='cache.result == true', type='success')
              | キャッシュの更新に成功しました。
            v-alert(:value='cache.result == false', type='error')
              | キャッシュの更新に失敗しました。
              br
              | {{ cache.message }}
          v-dialog(v-model='addDialog', persistent, max-width='600px')
            template(v-slot:activator='{ on }')
              v-btn(color='primary', depressed, v-on='on') 新規追加
            v-card
              v-card-title
                span.headline バナー追加
              v-card-text
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex(xs12)
                      v-text-field(label='遷移先URL*', required, v-model='banner.url')
                    img(:src="banner.bannerImageUrl", height="100px", width="200px")
                    v-flex(xs10)
                      v-text-field(label='画像URL*', required, v-model='banner.bannerImageUrl')
                    v-flex(xs12)
                      el-date-picker(type="datetime", format='yyyy/MM/dd HH:mm:ss', placeholder="公開開始日時*", v-model='banner.publishFromDt')
                    v-flex(xs12)
                      el-date-picker(type="datetime", format='yyyy/MM/dd HH:mm:ss', placeholder="公開終了日時*", v-model='banner.publishToDt')
                  small *indicates required field
              v-card-actions
                v-spacer
                v-btn(color='blue darken-1', flat='', @click='closeAddDialog') Close
                v-btn(color='blue darken-1', flat='', @click='addBanner') Save
          v-data-table.elevation-1(:headers='headers', :items='data')
            template(v-slot:items='props')
              td
                img(:src="props.item.bannerImageUrl", width="100px")
              td.text-xs {{ props.item.url }}
              td.text-xs {{ props.item.publishFromDt }}
              td.text-xs {{ props.item.publishToDt }}
              td.text-xs {{ props.item.regdt }}
              td.text-xs
                v-layout(row)
                  v-dialog(v-model='props.item.updateDialog', persistent, max-width='600px')
                    template(v-slot:activator='{ on }')
                      v-btn(color='warning', small, depressed, v-on='on', @click='openEditDialog(props.index)') 編集
                    v-card
                      v-card-title
                        span.headline バナー編集
                      v-card-text
                        v-container(grid-list-md)
                          v-layout(wrap)
                            v-flex(xs12)
                              v-text-field(label='遷移先URL*', required, v-model='banner.url')
                            img(:src="banner.bannerImageUrl", height="100px", width="200px")
                            v-flex(xs10)
                              v-text-field(label='画像URL*', required, v-model='banner.bannerImageUrl')
                            v-flex(xs12)
                              el-date-picker(type="datetime", format='yyyy/MM/dd HH:mm:ss', placeholder="公開開始日時*", v-model='banner.publishFromDt')
                            v-flex(xs12)
                              el-date-picker(type="datetime", format='yyyy/MM/dd HH:mm:ss', placeholder="公開終了日時*", v-model='banner.publishToDt')
                          small *indicates required field
                      v-card-actions
                        v-spacer
                        v-btn(color='blue darken-1', flat='', @click='closeEditDialog(props.index)') Close
                        v-btn(color='blue darken-1', flat='', @click='updateBanner(props.index)') Save
                  v-dialog(v-model='props.item.deleteDialog', persistent, max-width='290')
                    template(v-slot:activator='{ on }')
                      v-btn(color='error', dark, small, v-on='on') 削除
                    v-card
                      v-card-title.headline 確認してください。
                      img(:src="props.item.bannerImageUrl", width="200px")
                      v-card-text 本当に削除してもよろしいですか。削除をすると、元に戻すことはできません。
                      v-card-actions
                        v-spacer
                        v-btn(color='green darken-1', flat='', @click='props.item.deleteDialog = false') Cancel
                        v-btn(color='error darken-1', flat='', @click='deleteBanner(props.index)') Delete
</template>
<script>
import Vue from 'vue'
import API from '@/api/api.js'
import EmMenu from '@/components/organisms/EmMenu.vue'
import DisplayDataUtil from '@/utils/DisplayDataUtil'

export default {
  name: 'banner',
  components: {
    EmMenu
  },
  data () {
    return {
      cache: {
        result: null,
        message: ''
      },
      addDialog: false,
      updateDialog: false,
      banner: {},
      headers: [
        { text: 'バナー画像', value: 'bannerImageUrl', sortable: false },
        { text: '遷移先URL', value: 'url', sortable: false },
        { text: '公開開始日', value: 'publishFromDt', sortable: false },
        { text: '公開終了日', value: 'publishToDt', sortable: false },
        { text: '登録日時', value: 'regdt', sortable: false },
        { text: '', sortable: false }
      ],
      data: []
    }
  },
  computed: {
  },
  methods: {
    getBannerList () {
      API.GetBannerList().then(result => {
        this.data = []
        result.banners.forEach((data) => {
          this.data.push({
            bannerId: data.banner_id,
            bannerImageUrl: data.banner_image_url,
            url: data.url,
            publishFromDt: DisplayDataUtil.convertTimestampToDateFormat(data.publish_from_dt),
            publishToDt: DisplayDataUtil.convertTimestampToDateFormat(data.publish_to_dt),
            regdt: DisplayDataUtil.convertTimestampToDateFormat(data.regdt),
            updateDialog: false,
            deleteDialog: false
          })
        })
        if (this.data.length === 0) {
          this.noDataText = 'データまだ登録されていません。'
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    closeAddDialog () {
      // bannerは使いまわしているのでメモリを解放する
      this.addDialog = false
      this.banner = {}
    },
    addBanner () { // 新規のバナーを登録する
      API.AddBanner({ param: this.getRequestParam() }).then(result => {
        alert('バナーの登録に成功しました')
        this.updateCache()
        this.getBannerList() // refresh table
        this.addDialog = false
        this.banner = {}
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    openEditDialog (index) { // bannerに選択された行のデータを入力する
      // Object Typeは代入時は参照渡しなので明示的に値だけ渡す
      this.banner = Vue.util.extend({}, this.data[index])
    },
    closeEditDialog (index) {
      this.data[index].updateDialog = false
      this.banner = {}
    },
    updateBanner (index) { // バナーの更新をする
      API.UpdateBanner({ param: this.getRequestParam() }).then(result => {
        alert('バナーの更新に成功しました')
        this.updateCache()
        this.getBannerList() // refresh table
        this.data[index].updateDialog = false
        this.banner = {}
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    deleteBanner (index) {
      API.DeleteBanner({ param: { banner_id: this.data[index].bannerId } }).then(result => {
        alert('バナーの削除に成功しました')
        this.updateCache()
        this.getBannerList() // refresh table
        this.data[index].deleteDialog = false
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // this.bannerからAdd/Update用のリクエストパラメータを作成する
    getRequestParam () {
      return {
        banner_id: this.banner.bannerId,
        url: this.banner.url,
        banner_image_url: this.banner.bannerImageUrl,
        publish_from: DisplayDataUtil.convertTimestampToDateFormat(this.banner.publishFromDt),
        publish_to: DisplayDataUtil.convertTimestampToDateFormat(this.banner.publishToDt)
      }
    },
    updateCache () {
      API.UpdateCache().then(result => {
        if (result.message === 'ok') {
          // キャッシュ更新は成功
          this.cache = {
            result: true
          }
        } else if (result.message === 'error') {
          // キャッシュ更新は失敗
          this.cache = {
            result: false,
            message: result.error
          }
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    }
  },
  created () {
    this.getBannerList()
  }
}
</script>
<style lang="stylus" scoped>

.content-area
  display flex
  flex-direction column

</style>
